import { Injectable } from '@angular/core';
import { TableGuard } from '../table';

@Injectable({
  providedIn: 'root'
})
export class ChartsGuard extends TableGuard {
}